import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { apiQueryUserIpAndCountryInfo } from '../api/externalInterface';
import { AllAllowCountryList } from '../constants/quote';
export var useJoveCountryInfo = function useJoveCountryInfo() {
  /**
   * request
   */
  var requestUserCountryCode = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var defaultCountryCode,
          _yield$apiQueryUserIp,
          _yield$apiQueryUserIp2,
          res,
          country,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              defaultCountryCode = _args.length > 0 && _args[0] !== undefined ? _args[0] : 'GB';
              _context.next = 3;
              return apiQueryUserIpAndCountryInfo();

            case 3:
              _yield$apiQueryUserIp = _context.sent;
              _yield$apiQueryUserIp2 = _slicedToArray(_yield$apiQueryUserIp, 1);
              res = _yield$apiQueryUserIp2[0];
              country = '';

              if ((res === null || res === void 0 ? void 0 : res.country) === 'HK') {
                country = 'CN';
              } else {
                country = AllAllowCountryList.includes(res === null || res === void 0 ? void 0 : res.country) ? res.country : defaultCountryCode;
              }

              return _context.abrupt("return", country);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestUserCountryCode() {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    requestUserCountryCode: requestUserCountryCode
  };
};